<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<div class="ft40">
<img alt="Image" src="images/f001-01.jpg"/>
</div>
<p class="noindent"><span class="bold">Based near Exeter in Devon, Rebecca de Mendonça paints, teaches and writes. Her dynamic pastels capture the movement and atmosphere of subjects ranging from equestrian and landscape to figures and architecture.</span></p>
<p class="indent"><span class="bold">After graduating in Theatre Design, Rebecca’s early career was in theatre and interior design in London. She undertook portrait commissions of West End actors and dancers in English National Ballet.</span></p>
<p class="indent"><span class="bold">She is an Associate Member of the Society of Equestrian Artists, currently focusing her paintings on people working with horses, and moorland ponies. Rebecca has exhibited at the Mall Galleries in London with the Pastel Society and also as a finalist in the Artists of the Year Exhibition, 2019. Rebecca co-founded The New Pastel School in 2013.</span></p>
<div class="img_container">
<img alt="Image" src="images/f002-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Front.vue?60c27edb